import { Flex } from "@chakra-ui/react";
import { Tooltip } from "antd";
import { useState } from "react";

export default function InformacaoTitulo() {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Flex
      align="center"
      onClick={(ev) => {
        ev.stopPropagation();
        setShowTooltip((state) => !state);
      }}
      onMouseEnter={() => {
        setShowTooltip(true);
      }}
      onMouseLeave={() => {
        setShowTooltip(false);
      }}
    >
      <Tooltip
        overlayInnerStyle={{ borderRadius: "4px" }}
        placement="top"
        title={"Execução excedeu o previsto"}
        visible={showTooltip}
      >
        <Flex
          w="15px"
          h="15px"
          bg="red"
          color="white"
          rounded="full"
          justify="center"
          align="center"
          fontSize="9px"
        >
          i
        </Flex>
      </Tooltip>
    </Flex>
  );
}
